export const INITIALIZE_LANGUAGE_AND_AUTH_STATE =
  "INITIALIZE_LANGUAGE_AND_AUTH_STATE";
export const GET_LANGUAGE_AND_AUTH_STATE = "GET_LANGUAGE_AND_AUTH_STATE";
export const UPDATE_LANGUAGE_AND_AUTH_STATE = "UPDATE_LANGUAGE_AND_AUTH_STATE";
export const RESET_LANGUAGE_AND_AUTH_STATE = "RESET_LANGUAGE_AND_AUTH_STATE";
